<template>
  <div class="admin-layout">
    <!-- Header fixo no topo -->
    <Headerv2 @toggle-mobile-menu="toggleMobileMenu" />
    
    <!-- Container principal -->
    <div class="layout-container">
      <!-- Navbar lateral -->
      <Navbarv2 :is-mobile-menu-open="isMobileMenuOpen" @toggle-mobile-menu="toggleMobileMenu" />
      
      <!-- Área de conteúdo principal -->
      <main class="main-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import Headerv2 from './Headerv2.vue'
import Navbarv2 from './Navbarv2.vue'

export default {
  name: 'AdminLayoutv2',
  components: {
    Headerv2,
    Navbarv2
  },
  data() {
    return {
      isMobileMenuOpen: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    }
  }
}
</script>

<style>
body{
  width: -webkit-fill-available !important;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#app{
  width: -webkit-fill-available !important;
  height: 100vh;
  overflow: hidden;
}
</style>

<style scoped>
/* ================================
   LAYOUT PRINCIPAL
================================= */
.admin-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f8fafc;
  width: -webkit-fill-available;
  overflow: hidden;
}

.layout-container {
  display: flex;
  flex: 1;
  margin-top: 60px; /* Altura do header */
  height: calc(100vh - 60px);
  overflow: hidden;
  position: relative;
}

.main-content {
  overflow-y: auto;
  width: 100%;  
  flex: 1;
  margin-left: 260px; /* Largura do sidebar */
  padding: 24px;
  height: 100%;
  background: #f8fafc;
  overflow-x: hidden;
  max-width: calc(100vw - 260px); /* Previne overflow horizontal */
  box-sizing: border-box;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ================================
   RESPONSIVIDADE
================================= */
@media (max-width: 1024px) {
  .main-content {
    margin-left: 0;
    border-radius: 0;
    padding: 16px;
    max-width: 100vw;
    width: 100%;
    -webkit-overflow-scrolling: touch; /* Melhora o scroll em dispositivos iOS */
  }
}

@media (max-width: 768px) {
  .main-content {
    padding: 12px;
  }
  
  .layout-container {
    display: block; /* Alterado para block em mobile para evitar problemas de flex */
  }
}
</style> 